import React from "react";
import ImageCard from "./ImageCard";
import DocCard from "./DocCard";
import gettext from "../shared/utils/gettext";
import cropr from "../shared/utils/cropr";
import LinkedFields from "./LinkedFields";
import Icon from "../shared/icons/Icon";

type FileOverviewTableProps = {
  attachmentList: any[];
  editable: boolean;
  onClickRemove: (attachmentKey: string) => void;
  destroyable: boolean;
  onClickDestroy: (attachmentKey: string) => void;
  showAttachedTo?: boolean;
};
const FileOverviewTable = (props: FileOverviewTableProps) => {
  return (
    <div className="img py-3 overflow-auto">
      <table className="table">
        <thead>
          <tr>
            <th scope="col" />
            <th scope="col">{gettext("Name")}</th>
            {props.showAttachedTo && <th scope="col">{gettext("Attached to")}</th>}
            <th scope="col">{gettext("Timestamp")}</th>
            {props.editable && <th />}
            {props.destroyable && <th />}
          </tr>
        </thead>
        <tbody>
          {props.attachmentList.map((attachment, i) => (
            <tr key={i}>
              <td>
                {attachment.get("filetype").includes("image") ? (
                  <>
                    <a
                      data-lightbox="file_overview"
                      href={cropr.getImageUrl(attachment.get("key"))}
                    >
                      <ImageCard imageKey={attachment.get("key")} size={25} center={false} />
                    </a>
                  </>
                ) : (
                  <>
                    <a
                      type="button"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="allowClick w-100"
                      href={`/api/v1/document/get_by_key?key=${attachment.get("key")}&attachment=1`}
                    >
                      <DocCard
                        documentKey={attachment.get("key")}
                        documentFileType={attachment.get("filetype")}
                        size={25}
                        center={false}
                        iconColor="black"
                        className="font-size-1_5"
                      />
                    </a>
                  </>
                )}
              </td>
              <td>
                <div className="text-muted" style={{ fontSize: "0.6rem" }}>
                  {attachment.getName()}
                </div>
              </td>
              {props.showAttachedTo && (
                <td>
                  <LinkedFields {...attachment.getLinks()} />
                </td>
              )}
              <td>
                <div className="text-muted" style={{ fontSize: "0.6rem" }}>
                  {attachment.getTimestampString()}
                </div>
              </td>
              {props.editable && (
                <td>
                  <button
                    type="button"
                    className="btn position-absolute"
                    title={gettext("Unlink")}
                    data-image={attachment.get("key")}
                    onClick={() => props.onClickRemove(attachment.get("key"))}
                  >
                    <Icon icon={"close"} />
                  </button>
                </td>
              )}
              {props.destroyable && (
                <td>
                  <button
                    type="button"
                    className="btn position-absolute"
                    title={gettext("Delete")}
                    data-image={attachment.get("key")}
                    onClick={() => props.onClickDestroy(attachment.get("key"))}
                  >
                    <Icon icon={"delete"} />
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default FileOverviewTable;
